let Registration = {
    init: function () {
        this.bind();
    },

    bind: function () {
        if ($('.auth-register-form').length) {
            this.validation();
        }
    },

    validation() {
        let form = $('.needs-validation');

        Array.prototype.filter.call(form, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    form.classList.add('invalid');
                    event.preventDefault();
                }
                form.classList.add('was-validated');
            });
        });
    }
};


$().ready(() => {
    window.Frontend.Registration = Registration;
    window.Frontend.Registration.init();
});
